// Normalizar texto. Lo usan la API (claves, slugs) y la web (avisar antes de mandar).

/** Normaliza un nombre a una clave: "Martín F." -> "martin-f" */
export function aClave(nombre: string): string {
  return nombre
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '') // saca las tildes
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Saca espacios de más: "  Juan   Pérez " -> "Juan Pérez" */
export function limpiar(texto: string): string {
  return texto.replace(/\s+/g, ' ').trim();
}

const LARGO_SLUG = 40;

/** El pedazo del link público: "Abierto de Octubre 2026" -> "abierto-de-octubre-2026" */
export function aSlug(nombre: string): string {
  const base = aClave(nombre).slice(0, LARGO_SLUG).replace(/-+$/, '');
  return base || 'torneo';
}

/**
 * El primer slug libre: "abierto", "abierto-2", "abierto-3"...
 * El slug no cambia nunca después de creado: es el link que ya circuló por WhatsApp.
 */
export function slugLibre(base: string, usados: ReadonlySet<string>): string {
  if (!usados.has(base)) return base;
  for (let n = 2; ; n++) {
    const candidato = `${base}-${n}`;
    if (!usados.has(candidato)) return candidato;
  }
}
